import React from 'react';

/** Single skeleton line / block */
export function SkeletonLine({ width = '100%', height = 14, style }) {
  return (
    <div
      className="skeleton"
      style={{ width, height, borderRadius: 6, ...style }}
    />
  );
}

/** Skeleton machine card */
export function SkeletonMachineCard() {
  return (
    <div style={{
      background: 'var(--bg-surface)',
      border: '1px solid var(--border-hair)',
      borderLeft: '4px solid var(--border-strong)',
      borderRadius: 'var(--r-lg)',
      padding: 'var(--card-pad)',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
        <SkeletonLine width="55%" height={14} />
        <SkeletonLine width="20%" height={22} style={{ borderRadius: 20 }} />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginTop: 8 }}>
        {[0, 1].map(i => (
          <div key={i}>
            <SkeletonLine width="60%" height={10} style={{ marginBottom: 6 }} />
            <SkeletonLine width="80%" height={16} />
          </div>
        ))}
      </div>
    </div>
  );
}

/** Skeleton stat tile */
export function SkeletonStatTile() {
  return (
    <div style={{
      background: 'var(--bg-surface)',
      border: '1px solid var(--border-hair)',
      borderRadius: 'var(--r-lg)',
      padding: 'var(--card-pad)',
    }}>
      <SkeletonLine width="50%" height={10} style={{ marginBottom: 12 }} />
      <SkeletonLine width="40%" height={36} style={{ marginBottom: 8 }} />
      <SkeletonLine width="65%" height={10} />
    </div>
  );
}

/** Skeleton table row */
export function SkeletonTableRow({ cols = 5 }) {
  return (
    <tr style={{ borderBottom: '1px solid var(--border-hair)' }}>
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i} style={{ padding: '12px 16px' }}>
          <SkeletonLine width={i === 0 ? '80%' : '60%'} height={12} />
        </td>
      ))}
    </tr>
  );
}

/** Full page skeleton loader with branded spinner */
export function PageLoader() {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      minHeight: '40vh', gap: 16,
    }}>
      <div style={{
        width: 36, height: 36,
        border: '3px solid var(--border-subtle)',
        borderTopColor: 'var(--accent)',
        borderRadius: '50%',
        animation: 'atoms-spin 0.8s linear infinite',
      }} />
      <span style={{
        fontFamily: 'var(--font-sans)',
        fontSize: 13, color: 'var(--ink-500)',
      }}>
        Loading…
      </span>
    </div>
  );
}
